import React from 'react';
import { v4 as uuid } from 'uuid';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { joinGame } from '../actions/game';
import { saveRoomData } from '../actions/saveRoom';
import { Navbar } from '../components/Navbar';
import { InGameButton } from '../components/InGameButton';
import TimeButtons from '../components/TimeButtons';
import FactionButtons from '../components/FactionButtons';
import '../styles/lobby.css';

const ENDPOINT = "http://127.0.0.1:8080";

const io = require("socket.io-client");
const socket = io(ENDPOINT, {
  transports: ['websocket', 'polling', 'flashsocket']
});

export class UnwrappedLobby extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matchFound: false,
      player: this.props.authedUser,
      roomId: uuid(),
      rooms: {},
      joinRoom: '',
      factionPick: null,
      factionPicked: false,
      timeOptions: {
        1: [1, 1],
        2: [3, 2],
        3: [5, 3],
        4: [10, 5],
        5: [20, 10],
        6: [30, 20]
      },
      timePick: null,
      timPicked: false
    }

    socket.on('getRooms', data => {
      this.setState({ rooms: data.filteredRooms });
    })

    // socket.on('deleteRoom', data => {
    //   this.setState({
    //     rooms: {
    //       ...this.state.rooms,
    //       [data.roomId]: data
    //     }
    //   });
    // })

    socket.on('toGameRoom', data => {
      let rooms = { ...this.state.rooms };
      let player0 = data.rooms[data.roomId].waitingRoom[0].player.id;
      let player1 = data.rooms[data.roomId].waitingRoom[1].player.id;

      if (this.state.player.id === player0 || this.state.player.id === player1) {
        this.props.joinGameAction(data.roomId);
        this.props.saveRoomDataAction(data.roomId);
        this.setState({ matchFound: true });
      }
      
      delete rooms[data.roomId];
      this.setState({
        ...this.state,
        rooms: rooms
      })
    })

    socket.on('updateRooms', data => {
      this.setState({
        rooms: {
          ...this.state.rooms,
          [data.roomId]: data.rooms[data.roomId]
        }
      });
    })

    this.onPickFaction = this.onPickFaction.bind(this);
  }

  createRoom = () => {
    socket.emit('createRoom', {
      roomId: this.state.roomId,
      player: this.state.player,
      faction: this.state.factionPick
    })
  }

  joinRoom = (roomId) => {
    socket.emit('joinRoom', {
      roomId: roomId,
      player: this.state.player,
      faction: this.state.factionPick
    });
  }

  pickTime = (event) => {
    this.setState({
      timePick: this.state.timeOptions[event.target.value],
      timePicked: true
    });
  }

  onPickFaction = (event) => {
    this.setState({
      factionPick: event.target.value,
      factionPicked: true
    });
  }

  componentDidMount() {
    socket.emit('requestRooms');
  }

  render() {
    // const { inGame } = this.props;
    return (
      <div className="lobby">
        <Navbar />
        <div className="lobby-options">
          <div className="create-options">
            <FactionButtons onChange={this.onPickFaction} />
            <TimeButtons onChange={this.pickTime} />
            <button className="create-room" disabled={!this.state.factionPicked || !this.state.timePicked} onClick={() => this.createRoom()}>
              CREATE ROOM
            </button>
          </div>
          <div className="game-rooms">
            {Object.keys(this.state.rooms).map((room, id) => {
              return (
                <div
                  key={id} 
                  className="room-item"
                >
                  <div className="room-details">
                    vs. {this.state.rooms[room].waitingRoom[0].player.name}
                  </div>
                  <br />
                  {this.state.player.id !== this.state.rooms[room].waitingRoom[0].player.id &&
                    <button className="join-room" disabled={!this.state.factionPicked} onClick={() => this.joinRoom(room)}>
                      JOIN
                    </button>
                  }
                  {this.state.matchFound &&
                    <Redirect to={{
                      pathname: `/${room}`,
                      state: {
                        roomId: room,
                        faction: this.state.factionPick,
                        // time: this.state.timePick
                      }
                    }} />
                  }
                </div>
              )
            })}
          </div>
        </div>
        <InGameButton />
      </div>
    );
  }
}

function mapStateToProps ({ authedUser, inGame, room }) {
  return {
    authedUser,
    inGame,
    room
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    joinGameAction: () => {
      dispatch(joinGame()) 
    },
    saveRoomDataAction: roomId => {
      dispatch(saveRoomData(roomId));
    }
  }
}

export const Lobby = connect(mapStateToProps, mapDispatchToProps)(UnwrappedLobby);